var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.id ? _c("el-popover", {
    attrs: {
      placement: "right",
      title: "",
      width: "800",
      trigger: "hover"
    },
    on: {
      show: _vm.show
    }
  }, [_vm.init ? _c("div", [_c("el-descriptions", {
    attrs: {
      title: "作业信息",
      size: "small"
    }
  }, [_c("el-descriptions-item", {
    attrs: {
      label: "作业编号"
    }
  }, [_vm._v(_vm._s(_vm.form.c01TaskCode))]), _c("el-descriptions-item", {
    attrs: {
      label: "被审客户名称"
    }
  }, [_vm._v(_vm._s(_vm.form.c01CusName))]), _c("el-descriptions-item", {
    attrs: {
      label: "所属部组"
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.getStrucName(_vm.form.c01StrucCode)) + "(" + _vm._s(_vm.form.c01StrucCode) + ")")])]), _c("el-descriptions-item", {
    attrs: {
      label: "业务类型",
      span: 2
    }
  }, [_c("span", [_vm._v(_vm._s(_vm._f("getBTypeName")(_vm.form.c01N01Code, "name")) + "(" + _vm._s(_vm.form.c01N01Code) + ")")])]), _c("el-descriptions-item", {
    attrs: {
      label: "报告时间"
    }
  }, [_c("div", {
    staticStyle: {
      "line-height": "normal"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("date")(_vm.form.c01StartDate, "yyyy-MM-dd")) + " ~ " + _vm._s(_vm._f("date")(_vm.form.c01EndDate, "yyyy-MM-dd")) + " ")])]), _c("el-descriptions-item", {
    attrs: {
      label: "作业名称",
      span: 2
    }
  }, [_vm._v(_vm._s(_vm.form.c01TaskName))]), _c("el-descriptions-item", {
    attrs: {
      label: "创建人/日期"
    }
  }, [_vm._v(_vm._s(_vm.form.c01CreateStaffName) + "/" + _vm._s(_vm._f("date")(_vm.form.c01CreateDate, "yyyy-MM-dd")))]), _c("el-descriptions-item", {
    attrs: {
      label: "现场负责人",
      span: 1
    }
  }, [_vm._v(_vm._s(_vm.getStaffName(_vm.form.leaders)))]), _c("el-descriptions-item", {
    attrs: {
      label: "主管经理",
      span: 1
    }
  }, [_vm._v(_vm._s(_vm.getStaffName(_vm.form.n21StaffName)))]), _c("el-descriptions-item", {
    attrs: {
      label: "主管合伙人",
      span: 1
    }
  }, [_vm._v(_vm._s(_vm.getStaffName(_vm.form.partners)))]), _c("el-descriptions-item", {
    attrs: {
      label: "四级质控人员",
      span: 2
    }
  }, [_vm._v(_vm._s(_vm.getStaffName(_vm.form.quality4)))]), _c("el-descriptions-item", {
    attrs: {
      label: "五级质控人员",
      span: 2
    }
  }, [_vm._v(_vm._s(_vm.getStaffName(_vm.form.quality5)))]), _c("el-descriptions-item", {
    attrs: {
      label: "参与人员",
      span: 3
    }
  }, [_vm._v(_vm._s(_vm.getStaffName(_vm.form.participants)))])], 1)], 1) : _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticStyle: {
      height: "60px"
    }
  }), _c("span", {
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_c("cpsc-icon", {
    staticStyle: {
      "font-size": "22px"
    },
    attrs: {
      hover: true,
      "is-iconfont": true,
      name: "a-Group175"
    }
  })], 1)]) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };